const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/components/MetaKat/utils.ts';
import { MetaKatItem, MetaKatItemReference } from '../../../../defs/kisim';
import _ from 'lodash';

export const getMenuItemValue = (item: MetaKatItem, valuePath: string): string => {
    return _.get(item, valuePath);
};

export const getMenuItemLabel = (item: MetaKatItem, labelPath: string): string => _.get(item, labelPath);

export const findMetaKatItemByValue = (value: string | MetaKatItemReference | undefined, valuePath?: string) => {
    if (value) {
        if (typeof value === 'string') {
            if (valuePath) {
                return (item: MetaKatItem) => getMenuItemValue(item, valuePath) === value;
            }
        } else {
            return (item: MetaKatItem) => item.KAT === value.KAT && item.FKEY === value.FKEY;
        }
    }
    return (item: MetaKatItem) => false;
};
